export class DefaultData {
    id: string;
    name: string;

    constructor(values: { id: string, name: string }) {

        this.id = values.id;
        this.name = values.name;
    }
}